import React from 'react';
import { NavLink } from 'react-router-dom';

import { Card } from '../chunk';

export default class UserBanner extends React.Component {

	render() {

		const user = this.props.user;

		const media = (
			<NavLink to={`/users/${user.id}/`}>
				<div className="avatar" style={{backgroundImage: `url(/avatare/${user.avatar})`}}></div>
			</NavLink>
		);

		return (
			<Card inline media={media}> 
				{user.name} 
				<span className="comment-meta">{this.props.meta}</span>
			</Card>
		);
	}
};


export class Avatar extends React.Component {

	render() {

		const { user } = this.props;
		const style = this.props.style || {};
		style.backgroundImage = `url(/avatare/${user.avatar})`;

		if(user) {
			return <div className="avatar" style={style}></div>
		}
		return null;
	}
}

/*
export class PostActions extends React.Component {

	render() {

		const edit = <button className="button button--icon comment-subicon"
					onClick={() => this.setState({isEdit: true})}>
					<FontAwesomeIcon icon="edit" />
			</button>;

		return (<React.Fragment>
			<CommentVote commentId={this.props.id} votes={this.props.votes} />
			{(this.props.user.id === data.clientCredentials.id) && edit}
		</React.Fragment>);
	}
}*/




// WEBPACK FOOTER //
// ./src/components/user/UserBanner.js